import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    styles: {
      global: (props) => ({
        body: {
          margin: 0,
          fontFamily: "-apple-system, 'Plus Jakarta Sans', sans-serif",
          backgroundColor: "#000000",
          color: "#fffcf0",
        },
      }),
    },
  });

export default theme;